/**
 * usePageTitle — set `document.title` for the current route.
 *
 * Why bother:
 *   • Screen readers announce the title on every navigation; without
 *     it, every page sounds like "Market Melee — multiplayer crypto
 *     card game" (the static index.html title) and a blind user
 *     can't tell they actually moved.
 *   • Browser tabs, history, bookmarks, and the macOS Mission
 *     Control "Tab Groups" search all key on the title.
 *   • The page title is also used by Sentry's session breadcrumb
 *     for "user navigated to ___".
 *
 * Convention: `${page} — Market Melee` so brand stays at the end
 * (matching the index.html static title's flavour).
 */
import { useEffect } from "react";

const SUFFIX = "Market Melee";

export function usePageTitle(page) {
  useEffect(() => {
    const prev = document.title;
    document.title = page ? `${page} — ${SUFFIX}` : SUFFIX;
    return () => {
      document.title = prev;
    };
  }, [page]);
}
